var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcExportZip"},[_c('span',{staticClass:"MatcToolbarScreenListPreviewWrapper MatcCreateBtnElement MatcToolbarDropDownButtonItem",on:{"click":_vm.downloadZip}},[_c('span',{staticClass:"mdi mdi-file-code-outline"})])])}
var staticRenderFns = []

export { render, staticRenderFns }